import { Box } from '@mui/material';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import BackHandIcon from '@mui/icons-material/BackHand';
import EventNoteIcon from '@mui/icons-material/EventNote';

import ReportReceivedPaymentsList from '../Components/Report/ReportReceivedPaymentsList';
import ReportCustomersToInvoice from '../Components/Report/ReportCustomersToInvoice';
import ReportCustomersWithoutPayment from '../Components/Report/ReportCustomersWithoutPayment';
import ReportReturnNotes from '../Components/Report/ReportReturnNotes';
import ReportAppointmentsOverview from '../Components/Report/ReportAppointmentsOverview';

function Report() {

	let location = useLocation();

	const displayNavigation = location.pathname.endsWith("/reports");
	const displayReceivedPayments = location.pathname.endsWith("/received-payments");
	const displayCustomerToInvoice = location.pathname.endsWith("/customers-to-invoice");
	const displayCustomerWithoutPayments = location.pathname.endsWith("/customers-without-payment");
	const displayReturnNotes = location.pathname.endsWith("/return-notes");
	const displayAppointmentsOverview = location.pathname.endsWith("/appointments-overview");

	return (
		<>
			{displayNavigation && <>
				<h5>Reportistica</h5>
				<Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
					<nav aria-label="main mailbox folders">
						<List>
							<Link to={'/cms/reports/received-payments'} style={{textDecoration: 'inherit', color: 'inherit'}}>
								<ListItem disablePadding>
									<ListItemButton>
										<ListItemIcon>
											<EuroSymbolIcon />
										</ListItemIcon>
										<ListItemText primary="Pagamenti giornalieri ricevuti" />
									</ListItemButton>
								</ListItem>
							</Link>
							<Link to={'/cms/reports/customers-to-invoice'} style={{textDecoration: 'inherit', color: 'inherit'}}>
								<ListItem disablePadding>
									<ListItemButton>
										<ListItemIcon>
											<ReceiptIcon />
										</ListItemIcon>
										<ListItemText primary="Clienti da fatturare" />
									</ListItemButton>
								</ListItem>
							</Link>
							<Link to={'/cms/reports/customers-without-payment'} style={{textDecoration: 'inherit', color: 'inherit'}}>
								<ListItem disablePadding>
									<ListItemButton>
										<ListItemIcon>
											<ProductionQuantityLimitsIcon />
										</ListItemIcon>
										<ListItemText primary="Clienti senza pagamento" />
									</ListItemButton>
								</ListItem>
							</Link>
							<Link to={'/cms/reports/return-notes'} style={{textDecoration: 'inherit', color: 'inherit'}}>
								<ListItem disablePadding>
									<ListItemButton>
										<ListItemIcon>
											<BackHandIcon />
										</ListItemIcon>
										<ListItemText primary="Note di ritorno" />
									</ListItemButton>
								</ListItem>
							</Link>
							<Link to={'/cms/reports/appointments-overview'} style={{textDecoration: 'inherit', color: 'inherit'}}>
								<ListItem disablePadding>
									<ListItemButton>
										<ListItemIcon>
											<EventNoteIcon />
										</ListItemIcon>
										<ListItemText primary="Appuntamenti non chiusi" />
									</ListItemButton>
								</ListItem>
							</Link>
						</List>
					</nav>
				</Box>
			</>}

			{/* Report Grids */}
			{displayReceivedPayments && <>
				<ReportReceivedPaymentsList />
			</>}
			{displayCustomerToInvoice && <>
				<ReportCustomersToInvoice />
			</>}
			{displayCustomerWithoutPayments && <>
				<ReportCustomersWithoutPayment />
			</>}
			{displayReturnNotes && <>
				<ReportReturnNotes />
			</>}
			{displayAppointmentsOverview && <>
				<ReportAppointmentsOverview />
			</>}
		</>
	);
}

export default Report;
